import { mapState } from 'vuex'
import { setBodyBackground } from '@/helper'
import AppNavigation from '@/components/layout/AppNavigation'
import AppNavigationHorizontal from '@/components/layout/AppNavigationHorizontal'
import AppSearchBar from '@/components/layout/AppSearchBar'
import AppSettingsNavigation from '@/components/layout/AppSettingsNavigation'
import BackToTopButton from '@/components/ui/BackToTopButton'
import Chat from '@/components/overlays/Chat'
import AppBar from '@/components/layout/AppBar'
import { isMobile } from 'mobile-device-detect'

export default {
  components: {
    AppBar,
    AppNavigation,
    AppNavigationHorizontal,
    AppSearchBar,
    AppSettingsNavigation,
    BackToTopButton,
    Chat,
  },
  metaInfo() {
    return {
      title: this.$t('meta.title'),
      titleTemplate: this.pendingTranslations ?
        this.settings && this.settings.base_options && this.settings.base_options.meta_title :
        this.$t('meta.sub_title', { title: '%s' }),
    }
  },
  data() {
    return {
      showMainMenu: null,
      showSettingsMenu: null,
      openChat: false,
      windowSize: {
        x: 0,
        y: 0,
      },
    }
  },
  computed: {
    ...mapState('auth', [
      'user',
      'agb_nda_accepted',
      'routes',
      'settings',
      'settingsRoutes',
    ]),
    ...mapState('translations', [
      'pendingTranslations',
      'pendingAvailableLanguages',
    ]),
    ...mapState('app', ['error']),
    toggleView() {
      const viewArray = [
        'login',
        'forgot-password',
        'reset-password',
        'bubbletool-tv',
      ]
      return viewArray.indexOf(this.$route.name) !== -1
    },
  },
  watch: {
    error(name) {
      if (name && name !== this.$route.name) {
        this.$router.replace({ name })
      }
    },
    windowSize({ x, y }) {
      if (x > 1264) {
        this.showSettingsMenu = false
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.onScroll)
  },
  unmounted() {
    window.removeEventListener('scroll', this.onScroll)
  },
  mounted() {
    this.onResize()
    setInterval(this.setNoScroll, 500)
    if (this.customerConfig.images.bodyBg) {
      setBodyBackground(this.customerConfig.images.bodyBg)
    }
    /* Enforce download for PDF on mobile devices

     Event listener for all click events, checking for links and therein for pdf fileending.
     If PDF matches, enforce link is a download link
    */
    if (isMobile) {
      document.addEventListener('click', function(event) {
        const target = event.target
        const link = target.tagName.toLowerCase() === 'a' ? target : target.closest('a')
        if (link) {
          const href = link.getAttribute('href')
          const fileParts = href ? href.split('.') : []
          if (
            fileParts.length &&
            fileParts[fileParts.length - 1] &&
            fileParts[fileParts.length - 1].toLowerCase() === 'pdf'
          ) {
            link.setAttribute('download', true)
            link.removeAttribute('target')
          }
        }
      }, false)
    }
    window.onScroll = this.onScroll
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      window.windowSize = this.windowSize
    },
    setNoScroll() {
      const overlayOpen = Boolean(document.querySelector('div.v-overlay.v-overlay--active'))
      if (overlayOpen) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    },
    onScroll(immediate = true) {
      const header = document.querySelector('#appBar')
      const appHolder = document.querySelector('.v-main__wrap')

      const menu = header.childNodes[1]
      const childNodeCount = document.querySelector('#nav-menu') ?
        document.querySelector('#nav-menu').childElementCount :
        0
      if (this.windowSize.x < 960) {
        header.style.height = '50px'
      } else if (window.scrollY > 50) {
        menu.classList.add('position-on-scroll')
        appHolder.classList.add('scroll')
        header.style.height = '60px'
        // document.querySelector('#lan-switcher').childNodes[0].classList.add('hide-on-scroll')
        document.querySelector('#logo-image').childNodes[0].classList.add('resize-on-scroll')
        if (childNodeCount) {
          document.querySelector('#nav-menu').childNodes[childNodeCount - 1].classList.remove('on-scroll-switcher')
        }
      } else {
        menu.classList.remove('position-on-scroll')
        appHolder.classList.remove('scroll')
        header.style.height = '112px'
        // document.querySelector('#lan-switcher').childNodes[0].classList.remove('hide-on-scroll')
        document.querySelector('#logo-image').childNodes[0].classList.remove('resize-on-scroll')
        if (childNodeCount) {
          document.querySelector('#nav-menu').childNodes[childNodeCount - 1].classList.add('on-scroll-switcher')
        }
      }
      if (typeof window.initResize === 'function') {
        window.initResize(immediate, false)
      }
    },
  },
}
